import { Component, Input, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { Router, RouterModule, RouterOutlet } from "@angular/router";
import { SliderService } from "../../../shared/service/slider-service.service";
import { Subscription } from 'rxjs';
import { AuthFormsService, AuthFormsState } from 'src/app/shared/service/login-register-forms.service';
import { Slide } from 'src/app/shared/types/LoginSlide';


@Component({
  selector: 'app-auth-layout',
  imports: [
    RouterOutlet,
    RouterModule
],
  templateUrl: './auth-layout.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './auth-layout.component.css'
})
export class AuthLayoutComponent implements OnInit, OnDestroy {
 
  // Combined subscriptions
  private subscriptions = new Subscription();

  // state vars
  public authFormsState!: AuthFormsState
  @Input() loginState!: boolean
  
  get backgroundImage(): string {
    return `url(${this.currentSlide?.dogImage})`;
  }

  // slides
  public slides: Slide[] = [
    {
      mainText: "Välkommen till PetPals!",
      subText: "Petpals är sidan för djurägare! ",
      bgColor: "#F0BFCC",
      dogImage: "assets/images/dog13.png"
    },
    {
      mainText: "Träning, aktiviteter  och evenemang!",
      subText: "Hitta träningstips, roliga aktiviteter och evenemang för dig och ditt djur. ",
      bgColor: "#F9D885",
      dogImage: "assets/images/dog14.png"
    },
    {
      mainText: "Djurvänliga platser!",
      subText: "Hitta till djurvänliga platser, cafén, resturanger, hotell och flyg. ",
      bgColor: "#61D7AD",
      dogImage: "assets/images/dog15.png"
    },
    {
      mainText: "Hitta vänner!",
      subText: "Dela bilder, erfarenheter och aktiviteter med dina vänner eller hitta nya vänner! ",
      bgColor: " #6872A5",
      dogImage: "assets/images/cat2.png"
    },
  ];

  private activeInterval? : ReturnType<typeof setInterval> // Workaround to get the ts-typing
  public currentSlideIndex: number = 0;
  private nextSlideIndex: number = (this.currentSlideIndex + 1) % this.slides.length;
  public currentSlide: Slide = this.slides[this.currentSlideIndex];
  private intervalDuration : number = 5000;
  public isResetPwdForm: boolean = false;

  constructor(
    private sliderService : SliderService, 
    private authFormsService : AuthFormsService,
    private router : Router
  ) {
  }


  public ngOnInit() {    
    this.subscriptions.add(
      this.authFormsService.authFormsStateObservable$.subscribe(authFormsState => {
        this.authFormsState = authFormsState;
        this.isResetPwdForm = this.authFormsService.isResetPwdForm();
      })
    );

    this.subscriptions.add(
      this.sliderService.onToggleSlider().subscribe(loginState => {
        if (loginState)
          this.stopSlides();
        else 
          this.rollSlides();
      })
    );

    this.rollSlides();
  }


  public ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }


  public showLoginForm() {
    this.authFormsService.showLoginForm();
  }


  public rollSlides() {
    if(this.activeInterval)
      clearInterval(this.activeInterval)
    this.updateInterval()
  }


  private updateInterval () {
    this.activeInterval = setInterval(
      () => {
        this.currentSlide = this.slides[this.nextSlideIndex];
        this.currentSlideIndex = this.nextSlideIndex;
        this.nextSlideIndex = (this.nextSlideIndex + 1) % this.slides.length;
      }, 
      this.intervalDuration
    );
  }


  public stopSlides() {
    if (this.activeInterval)
      clearInterval(this.activeInterval);
  }


  public changeSlide(index : number) {
    this.currentSlide = this.slides[index];
    this.currentSlideIndex = index;
    this.nextSlideIndex = (index + 1) % this.slides.length;
    if (this.activeInterval) 
      clearInterval(this.activeInterval);
    this.updateInterval();
  }


  public returnToLoginForm() : void {    
    this.authFormsService.showLoginForm();
    this.router.navigate([['/']]);
  }
}
